import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { visitorFingerprint } from "../utils/fingerprint";
import { ChatState } from "./ChatState";

const DEFAULT_VISITOR: ChatUserInfo = {
    displayName: "Visitor",
    nick: "visitor:",
    typing: false
};

export interface DefaultStateOptions {
    enableErrorOverlay?: boolean;
}

export function createDefaultState(state?: Partial<ChatState>, options?: DefaultStateOptions): ChatState {

    if (!state) {
        state = {};
    }

    state.userId = state.userId ? state.userId : visitorFingerprint();
    state.visitorId = state.userId;

    // Determine if debug mode should be enabled
    let debugMode = false;
    if (typeof window !== 'undefined') {
        const localStorageSetting = window.localStorage?.getItem('xaErrorOverlay');
        if (localStorageSetting === 'enabled') {
            debugMode = true;
        } else if (localStorageSetting === 'disabled') {
            debugMode = false;
        } else if (options?.enableErrorOverlay) {
            // Use config option if no localStorage override
            debugMode = true;
        } else if (typeof (globalThis as any).__DEV__ !== 'undefined' && (globalThis as any).__DEV__) {
            // For React Native, default to true in development mode
            debugMode = true;
        }
    }

    return {
        connection: {
            connectionStatus: "offline",
            token: null,
            greetingRequested: false
        },
        accountStatus: "offline",
        departments: {},
        visitor: DEFAULT_VISITOR,
        agents: {},
        chats: [],
        lastTimestamp: 0,
        lastRatingRequestTimestamp: 0,
        hasRating: false,
        isChatting: false,
        queuePosition: 0,
        failureMsg: null,
        visitorId: visitorFingerprint(),
        chips: [],
        sessionExpiration: "24h",
        visuals: {},
        debugMode,
        ...state
    };
}

export const DEFAULT_STATE: ChatState = createDefaultState();